export default __webpack_public_path__ + "static/media/card2-1.1210b4a4.jpg";